import { call, put, takeLatest } from 'redux-saga/effects';
import { SiloGroupAT } from './actionTypes';
import { SiloGroupAPI } from "../../../services/api/siloGroupAPI";
import {silogroupAC} from "./actionCreators";
import {LoadingStatus} from "../../status";


//  Fetch Configuration ---
function* fetchSiloConfigRequest(action) {

    try {
        const response = yield call(SiloGroupAPI.getSiloConfiguration, action.payload);
        // The API service returns the full response data. We extract the array:
        yield put(silogroupAC.fetchSiloConfigSuccess(response));

    } catch (error) {
        yield put(silogroupAC.fetchSiloConfigFailure(error));
    }
}

// Save Configuration ---
function* saveSiloConfigRequest(action) {
    const { devicePk, payload } = action.payload;

    try {
        const response = yield call(SiloGroupAPI.saveSiloConfiguration, devicePk, payload);

        yield put(silogroupAC.saveSiloConfigSuccess(response));

        yield put(silogroupAC.setSiloGroupLoadingStatus(LoadingStatus.SUCCESS));
    } catch (error) {
        yield put(silogroupAC.saveSiloConfigFailure(error));
    }
}

export function* getSiloGroupTypesRequest() {
    try {

        const response = yield call(SiloGroupAPI.getSiloGroupTypes);

        yield put(silogroupAC.fetchSiloGroupTypeSuccess(response.data.results));
    } catch (error){
         yield put(silogroupAC.fetchSiloGroupTypesFailure(error));
    }
}



// --- Watcher Saga ---
export function* siloGroupSaga() {
    yield takeLatest(SiloGroupAT.FETCH_SILO_CONFIG_REQUEST, fetchSiloConfigRequest);
    yield takeLatest(SiloGroupAT.SAVE_SILO_CONFIG_REQUEST, saveSiloConfigRequest);
    yield takeLatest(SiloGroupAT.FETCH_SILO_GROUP_TYPE_REQUEST, getSiloGroupTypesRequest);
}